import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';
import './Testimonials.css';  // Custom styles
import { Link } from 'react-router-dom';

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, 
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  const { t } = useTranslation('tours');

  return (
    <section className="testimonials-section">

      {/* Why Us Section */}
      <section className="whyus">
        <h2 className='section-header'>{t('whyus.title')}</h2>
        <div className="whyus-container">
          {t('whyus.cards', { returnObjects: true }).map((card, index) => (
            <div className="whyus-card" key={index}>
              <h3><b>{card.title}</b></h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* About + Partners */}
      <section className="about-section">
        <div className="about-container">
          <p className="about-text" dangerouslySetInnerHTML={{ __html: t('about.intro') }} />
          
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <a 
              href="/contact" 
              style={{
                backgroundColor: '#3b2f2f',
                color: '#fffdfb',
                padding: '12px 24px',
                borderRadius: '4px',
                textDecoration: 'none',
                fontWeight: 'bold',
                fontFamily: 'Georgia, serif',
                fontSize: '1rem',
                display: 'inline-block',
                transition: 'background-color 0.3s ease'
              }}
              onMouseOver={e => e.currentTarget.style.backgroundColor = '#5a4949'}
              onMouseOut={e => e.currentTarget.style.backgroundColor = '#3b2f2f'}
            >
              {t('about.button')}
            </a>
          </div>
        </div>

        {/* Partners Section */}
        <div className='partners-wrapper'>
          <h3>{t('partners.title')}</h3>
          <hr />
          <p>{t('partners.description')}</p>

          <div className="partners-grid">
            <div className="partners-logo">
              <img src="/images/glenelg.png" alt="glenelg.org" />
            </div>
            <div className="partners-logo">
              <img src="/images/kenyaluk.png" alt="kenyalukmedicalfoundation.org" />
            </div>
            <div className="partners-logo">
              <img src="/images/tra.png" alt="Tourism Authority" />
            </div>
            <div className="partners-logo">
              <img src="/images/tripadviser.png" alt="TripAdvisor" />
            </div>
            <div className="partners-logo">
              <img src="/images/wings.png" alt="wingsofhope.org" />
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default Testimonials;
